export default __webpack_public_path__ + "static/media/20_header_stock.c3c16a81.png";